// export const getAPIUrl = () => {
//   if (window.location.host.startsWith("localhost")) {
//     return 'http://localhost:4000';
//   } else {
//     return 'https://monitor-api.remotexs.co';
//   }
// };
// export const title = "RemoteXS Monitor";


export const getAPIUrl = () => {
  if (window.location.host.startsWith("localhost")) {
    // return 'https://api-monitor.shalby.pyther.com';
    return 'http://127.0.0.1:7070';
  } else if (window.location.host.startsWith("monitor.007percent.com")) {
    return 'https://api-monitor.007percent.com';
  } else if (window.location.host.startsWith("monitor.pyther.com")) {
    return 'https://api-monitor.pyther.com';
  }else if (window.location.host.startsWith("monitor.shalby.pyther.com")) {
    return 'https://api-monitor.shalby.pyther.com';
  } else {
    return 'http://127.0.0.1:7070';
  }
};
export const title = "Shalby Monitor";
